import { BehaviorSubject } from "rxjs";
import type { PanelViewModelInterface } from '@nts/std/interfaces';
import { ComponentViewModel, ComponentViewModelUtility } from './component.view-model';

export class PanelViewModelUtility {
  /** @deprecated use ComponentViewModelUtility.getComponentById */
  static getPanelViewModel(panels: Map<string, PanelViewModelInterface>, panelId: string): PanelViewModelInterface {
    return ComponentViewModelUtility.getComponentById(panels, panelId, () => new PanelViewModel());
  }

  /** @deprecated use ComponentViewModelUtility.setIsVisible */
  static setIsVisible(panels: Map<string, PanelViewModelInterface>, panelId: string, value: boolean): PanelViewModelInterface {
    const panelVm = this.getPanelViewModel(panels, panelId);
    panelVm.isVisible = value;
    return panelVm;
  }

  /** @deprecated use ComponentViewModelUtility */
  static setShowAdditionalFields(panels: Map<string, PanelViewModelInterface>, panelId: string, value: boolean | null): PanelViewModelInterface {
    const panelVm = this.getPanelViewModel(panels, panelId);
    panelVm.showAdditionalFieldsOverride = value;
    return panelVm;
  }
}

export class PanelViewModel extends ComponentViewModel implements PanelViewModelInterface {

  protected internalDisableAdditionalFields = false;

  get disableAdditionalFields() {
    return this.internalDisableAdditionalFields;
  }
  set disableAdditionalFields(value: boolean) {
    if (this.internalDisableAdditionalFields !== value) {
      this.internalDisableAdditionalFields = value;
      this.onPropertyChanged('disableAdditionalFields');
      this.disableAdditionalFields$.next(value);
    }
  }

  disableAdditionalFields$ = new BehaviorSubject<boolean>(this.internalDisableAdditionalFields);

  protected internalShowAdditionalFieldsOverride: boolean | null = null;

  get showAdditionalFieldsOverride() {
    return this.internalShowAdditionalFieldsOverride;
  }
  set showAdditionalFieldsOverride(value: boolean | null) {
    if (this.internalShowAdditionalFieldsOverride !== value) {
      this.internalShowAdditionalFieldsOverride = value;
      this.onPropertyChanged('showAdditionalFieldsOverride');
      this.showAdditionalFieldsOverride$.next(value);
    }
  }

  showAdditionalFieldsOverride$ = new BehaviorSubject<boolean | null>(this.internalShowAdditionalFieldsOverride);

  protected internalIsCollapsed = false;

  get isCollapsed() {
    return this.internalIsCollapsed;
  }
  set isCollapsed(value: boolean) {
    if (this.internalIsCollapsed !== value) {
      this.internalIsCollapsed = value;
      this.onPropertyChanged('isCollapsed');
      this.isCollapsed$.next(value);
    }
  }

  isCollapsed$ = new BehaviorSubject<boolean>(this.internalIsCollapsed);
}
